import { render, staticRenderFns } from "./LegalContent.vue?vue&type=template&id=2bbcd54d&"
import script from "./LegalContent.vue?vue&type=script&lang=ts&"
export * from "./LegalContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports